import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/pricing")({
	component: Pricing,
});

function Pricing() {
	return (
		<div className="mx-auto max-w-[900px] px-6 py-16">
			<h1 className="font-display text-fg-strong mb-2 text-center text-4xl">
				Simple pricing
			</h1>
			<p className="text-fg-muted mb-12 text-center">
				Start free, upgrade when you need more.
			</p>

			<div className="grid grid-cols-1 gap-6 md:grid-cols-2">
				<div className="border-line-subtle bg-surface-raised rounded-lg border p-8">
					<h2 className="text-fg-strong mb-2 text-xl">Free</h2>
					<p className="text-fg-strong mb-6 text-4xl font-bold">
						$0
						<span className="text-fg-faint text-base font-normal">
							/month
						</span>
					</p>
					<ul className="text-fg-muted space-y-3 text-sm">
						<li>Up to 100 findings</li>
						<li>3 collections</li>
						<li>Basic export</li>
					</ul>
				</div>

				<div className="border-accent bg-surface-raised rounded-lg border p-8">
					<h2 className="text-fg-strong mb-2 text-xl">Pro</h2>
					<p className="text-fg-strong mb-6 text-4xl font-bold">
						$12
						<span className="text-fg-faint text-base font-normal">
							/month
						</span>
					</p>
					<ul className="text-fg-muted space-y-3 text-sm">
						<li>Unlimited findings</li>
						<li>Unlimited collections</li>
						<li>Advanced export (PDF, CSV)</li>
						<li>Priority support</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
